import type { IconSvgObject } from './types';

const PopsicleIcon: IconSvgObject = [
  ["path", { d: "M18.6464 11.6464L11.4497 4.44975C10.5215 3.52149 9.26247 3 7.94972 3C5.21605 3 2.99997 5.21608 2.99997 7.94975C2.99997 9.2625 3.52146 10.5215 4.44972 11.4497L11.6464 18.6464C11.8728 18.8728 12.1798 19 12.5 19C12.8201 19 13.1271 18.8728 13.3535 18.6464L18.6464 13.3536C18.8728 13.1272 19 12.8201 19 12.5C19 12.1799 18.8728 11.8728 18.6464 11.6464Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16 16L21 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default PopsicleIcon;
